import { CLEAR_ALL, SET_LOGOUT } from '../../../store/Types';

export const GETALL_CITIES = 'GETALL_CITIES';
export const ACTIVO_CITIES = 'ACTIVO_CITIES';
export const LOADING_GETALL_CITIES = 'LOADING_GETALL_CITIES';
export const PARAMS_CITIES = 'PARAMS_CITIES';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const citiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_CITIES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case ACTIVO_CITIES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_CITIES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_CITIES:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
